/**
 * AnimateInViewport
 * @description Přidává třídu elementům, které se objeví ve viewportu.
 * Komponenta nejprve projde všechny elementy s atributem data-fragment="AnimateInViewport.element"
 * a každému přidá třídu animated. Pomocí této třídy lze v CSS nastavit výchozí stav
 * animace elementu. Lze tak vytvořit jednotnou animaci pro všechny elementy
 * a zároveň i různé animace pro různé elementy/CSS komponenty.
 * Ve chvíli, kdy se element dostane do viewportu, přidá se mu třída show, která se používá
 * ke spuštění animace - v CSS konečný stav animace
 * @autor JTR + JMR
 * @property {number} [showTimeout] - Zpoždění (v ms) zobrazení elementu,
 * jakmile se objeví ve viewportu.
 * @property {number} [viewportPercentage] - Procento z výšky viewportu,
 * ve kterém se zobrazují elementy.
 * Např. Pokud chceme zobrazovat elementy až ve chvíli, kdy jsou ve 40% viewportu,
 * nastavíme tuto hodnotu na 0.6 - jedná se tedy o doplněk do jedné.
 */


import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import classNames from 'fg-frontend/src/lib/classNames';

const fragments = {
  ELEMENT: '[data-fragment="AnimateInViewport.element"]',
};

class AnimateInViewport extends WebComponent {
  constructor(props) {
    super(props);
    this.state = {
      shownElements: [],
      pageYoffset: window.pageYOffset,
    };
  }
  didMount() {
    this.elements = [...this.element.querySelectorAll(fragments.ELEMENT)];
    this.elements.map(this.addClass);
    this.animatedInterval = setInterval(() => {
      if (this.state.pageYoffset !== window.pageYOffset) {
        this.elements.map(this.storeElements);
        this.setState({
          pageYoffset: window.pageYOffset,
        });
      }
    }, 100);
    this.elements.map(this.storeElements);
  }
  willUnMount() {
    clearInterval(this.animatedInterval);
    this.elements = null;
  }
  addClass = (item) => {
    classNames(item, {
      'animated': true,
    });
  };
  storeElements = (item) => {
    if (this.state.shownElements.indexOf(item) === -1) {
      if (this.isElementInViewport(item)) {
        this.setState({
          shownElements: [...this.state.shownElements, item],
        });
        setTimeout(() => {
          classNames(item, {
            'show': true,
          });
        }, AnimateInViewport.defaultProps.showTimeout);
      }
    }
  };
  isElementInViewport = (el) => {
    let top = el.offsetTop;
    let left = el.offsetLeft;
    const width = el.offsetWidth;
    const height = el.offsetHeight;

    while (el.offsetParent) {
      el = el.offsetParent;
      top += el.offsetTop;
      left += el.offsetLeft;
    }

    return (
      top < (window.pageYOffset + (window.innerHeight * AnimateInViewport.defaultProps.viewportPercentage)) &&
      left < (window.pageXOffset + window.innerWidth) &&
      (top + height) > window.pageYOffset &&
      (left + width) > window.pageXOffset
    );
  };
}

AnimateInViewport.defaultProps = {
  showTimeout: 0,
  viewportPercentage: 0.8,
};

export default AnimateInViewport;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/AnimateInViewport.js